import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageComponent } from './page/page.component';
import { PageSideColumnComponent } from './page/page-side-column/page-side-column.component';
import { PageMainAreaComponent } from './page/page-main-area/page-main-area.component';
import { PageSectionComponent } from './page/page-main-area/page-section/page-section.component';
import { PageBlockComponent } from './page/page-main-area/page-block/page-block.component';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    PageComponent,
    PageSideColumnComponent,
    PageMainAreaComponent,
    PageSectionComponent,
    PageBlockComponent,
  ],
  exports: [
    PageComponent,
    PageSideColumnComponent,
    PageMainAreaComponent,
    PageSectionComponent,
    PageBlockComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatProgressSpinnerModule,
    MatIconModule,
  ],
})
export class PageModule {}
